'use strict';

var mimicFn = require('mimic-fn');

module.exports = function (fn) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof fn !== 'function') {
    throw new TypeError("Expected the first argument to be a function, got `".concat(typeof fn, "`"));
  }

  var timeout;
  var result;

  var debounced = function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;

    var later = function later() {
      timeout = null;

      if (!options.immediate) {
        result = fn.apply(context, args);
      }
    };

    var callNow = options.immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, options.wait || 0);

    if (callNow) {
      result = fn.apply(context, args);
    }

    return result;
  };

  mimicFn(debounced, fn);

  debounced.cancel = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};